<template>
  <div>
    <MasterLayout>
      <div class="fuel_consumption_row row">
        <div class="card_container">
          <div class="row align-items-center fuel_consumption_buttons_row">
            <div class="col-md-12 fuel_consumption_btn_div mt-3">
              <div
                class="fuel_consumption_button"
                style="height: 80px; width: 80px"
              >
                <h6 class="primary_text" style="">{{ maintenanceCount }}</h6>
              </div>
              <div class="text-center voucher_type mt-2 primary_text">
                {{ $t("text.pumpsMaintenance.totalMaintenence") }}
              </div>
            </div>
          </div>
        </div>

        <div
          class="fuel_consumption_row_right_section_nw pmp__bg"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.92), rgb(12, 4, 31, 0.92)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="row align-items-center" style="height: 100%">
            <div class="col-md-12">
              <div
                class="transaction_period_text text-center branch__sales__text"
                style="font-size: 22px"
              >
                {{ $t("text.pumpsMaintenance.maintenence") }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="mt-3 pump__details__section_2">
        <div class="row add_driver_row record__expenses">
          <div
            v-show="formMode == 'create'"
            class="col-md-12 col-lg-4 mt-3"
            style="padding-right: 0px"
          >
            <div class="drivers_list">
              <div class="product_summary__wrapper" style="padding: 1px">
                <div class="input__group__block mt-5" style="width: 90%">
                  <h6 class="expense__header mt-3 text-center">
                    <img stc="@/assets/img/description.png" width="25px" />
                    {{ $t("text.pumpsMaintenance.recordMaintenance") }}
                  </h6>
                </div>

                <!-- Status -->

                <div
                  class="input__group__block mt-4"
                  ref="account_textbox"
                  style="width: 90%"
                >
                  <label class="required">{{
                    $t("text.pumpsFault.status")
                  }}</label>
                  <div class="input__block" ref="account_number_input_div">
                    <select v-model="status">
                      <option disabled selected>
                        {{ $t("text.pumpsFault.selectPumpStatus") }}
                      </option>
                      <option value="pending">
                        {{ $t("text.pumpsFault.pending") }}
                      </option>
                      <option value="fixing">
                        {{ $t("text.pumpsFault.fixing") }}
                      </option>
                      <option value="fixed">
                        {{ $t("text.pumpsFault.fixed") }}
                      </option>
                      <option value="not fixed">
                        {{ $t("text.pumpsFault.notFixed") }}
                      </option>
                    </select>
                  </div>
                  <div ref="account_number_error"></div>
                </div>

                <div class="input__group__block mt-4" style="width: 90%">
                  <label class="required">{{
                    $t("text.pumpsMaintenance.servicingCompany")
                  }}</label>
                  <div class="input__block">
                    <input
                      type="text"
                      :placeholder="
                        $t('text.pumpsMaintenance.servicingCompany')
                      "
                      class="form-control"
                      v-model="servicingCompany"
                    />
                  </div>
                </div>
                <div class="input__group__block mt-4" style="width: 90%">
                  <label class="required">{{
                    $t("text.pumpsMaintenance.technicianName")
                  }}</label>
                  <div class="input__block">
                    <input
                      type="text"
                      :placeholder="$t('text.pumpsMaintenance.technicianName')"
                      class="form-control"
                      v-model="technicianName"
                    />
                  </div>
                </div>
                <div class="input__group__block mt-4" style="width: 90%">
                  <label class="required">{{
                    $t("text.pumpsMaintenance.remarks")
                  }}</label>
                  <div class="input__block">
                    <input
                      type="text"
                      :placeholder="$t('text.pumpsMaintenance.remarks')"
                      class="form-control"
                      v-model="remarks"
                    />
                  </div>
                </div>
                <div class="input__group__block mt-4" style="width: 90%">
                  <label class="required">{{
                    $t("text.pumpsMaintenance.findings")
                  }}</label>
                  <div class="input__block">
                    <input
                      type="text"
                      :placeholder="$t('text.pumpsMaintenance.findings')"
                      class="form-control"
                      v-model="findings"
                    />
                  </div>
                </div>
                <div class="input__group__block mt-4" style="width: 90%">
                  <label class="required">{{
                    $t("text.pumpsMaintenance.keyReturned")
                  }}</label>
                  <div class="input__block">
                    <select v-model="keyReturned">
                      <option disabled selected>
                        {{ $t("text.pumpsMaintenance.trueOrFalse") }}
                      </option>
                      <option value="true">
                        {{ $t("text.pumpsMaintenance.true") }}
                      </option>
                      <option value="false">
                        {{ $t("text.pumpsMaintenance.false") }}
                      </option>
                    </select>
                  </div>
                </div>
                <!-- <div class="input__group__block mt-4" style="width: 90%">
                  <label class="required">{{$t('text.pumpsMaintenance.pumpFunctional')}}</label>
                  <div class="input__block">
                    <select v-model="pumpFunctional">
                      <option disabled selected>{{$t('text.pumpsMaintenance.trueOrFalse')}}</option>
                      <option value="true">{{$t('text.pumpsMaintenance.true')}}</option>
                      <option value="false">{{$t('text.pumpsMaintenance.false')}}</option>
                    </select>
                  </div>
                </div> -->
                <div class="text-center py-3 mt-3">
                  <button
                    class="sales_target_btn text-center"
                    @click="recordMaintenance($event)"
                    :disabled="isButtonDisabled ? true : null"
                    :style="[
                      isButtonDisabled
                        ? { cursor: 'not-allowed' }
                        : { cursor: 'pointer' },
                    ]"
                  >
                    {{ $t("text.pumpsMaintenance.recordMaintenance") }}
                    <span></span>
                  </button>
                  <img
                    src="@/assets/img/git_loader.gif"
                    style="display: none"
                    width="35px"
                    class="ml-3 loader"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 col-lg-8 mt-3">
            <TableLoader :showLoader="showLoader" />
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :locale="usedLang"
            >
              <e-columns>
                <e-column
                  field="date"
                  width="200"
                  :headerText="$t('text.pumpsMaintenance.date')"
                  :sortComparer="sortComparer"
                ></e-column>
                <e-column
                  width="300"
                  field="findings"
                  :headerText="$t('text.pumpsMaintenance.findings')"
                ></e-column>
                <e-column
                  width="180"
                  field="isResolved"
                  :headerText="$t('text.pumpsMaintenance.resolved')"
                ></e-column>
                <e-column
                  field="technicianName"
                  width="200"
                  :headerText="$t('text.pumpsMaintenance.technician')"
                ></e-column>
                <!-- <e-column field="pumpFunctional" width="200" :headerText="$t('text.pumpsMaintenance.pumpFunctional')"></e-column> -->
                <e-column
                  field="servicingCompany"
                  width="200"
                  :headerText="$t('text.pumpsMaintenance.servicingCompany')"
                ></e-column>
                <e-column
                  field="remarks"
                  width="200"
                  :headerText="$t('text.pumpsMaintenance.remarks')"
                ></e-column>

                <e-column
                  width="250"
                  :template="actionButtonsTemplate"
                  :headerText="$t('text.actionButtons.title')"
                ></e-column>
              </e-columns>
            </ejs-grid>
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import backgroundUrl from "@/assets/img/pumpimage.png";
import configObject from "@/config";
import Logo from "@/assets/img/logo.png";
import TableLoader from "@/components/tableLoader/index";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
  GridPlugin,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
import actionTemplate from "@/components/TableTemplates/fault-maintenance/maintenanceTemplate.vue";
let $ = JQuery;

export default {
  name: "Pump_Details",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      id: this.$route.query.id,
      editPump: "",
      editTank: "",
      maintObj: {},
      type: "select type",
      // maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      // dateRange: this.startDate,
      // pluginStartDate: this.$moment().format("D-M-YYYY"),
      // startDate: this.$moment().format("MMMM D, YYYY"),
      // tanks: [],
      editFaultDetails: null,
      pumps: [],
      tanks: [],
      pumpList: [],
      tankList: [],
      products: [],
      maintenanceCount: 0,
      MaintainanceCount: 0,
      backgroundUrl,
      status: this.$t("text.pumpsFault.selectPumpStatus"),
      pumpStatus: this.$t("text.pumpsMaintenance.showAll"),
      urgencyLevel: "urgency Level",
      servicingCompany: null,
      technicianName: null,
      remarks: null,
      findings: null,
      keyReturned: this.$t("text.pumpsMaintenance.trueOrFalse"),
      // pumpFunctional: this.$t('text.pumpsMaintenance.trueOrFalse'),
      // date: null,
      fault: "select fault",
      showStatusOPtions: false,
      formIsValid: false,
      isButtonDisabled: false,
      showLoader: false,
      branch: {},
      branchId: this.$route.query.branchId,
      formMode: "create",
      bankAccounts: null,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      actionButtonsTemplate: function () {
        return {
          template: actionTemplate,
        };
      },
      // actionButtonsTemplate: function () {
      //   return {
      //     template: Vue.component("actionButtonsTemplate", {
      //       template:
      //         '<div class="btn-group btn-group-sm" role="group">' +
      //         '<button type="button" class="btn btn-outline-danger px-4 py-2" title="Delete Fault" v-on:click="removeMaintenance(data.id)" >' +
      //         "Delete" +
      //         "</button>" +
      //         "</div>",
      //       data: function () {
      //         return {
      //           data: {},
      //         };
      //       },
      //       methods: {
      //         editMaintenance: function (maint) {
      //           this.maintObj = maint;

      //           this.$eventHub.$emit("__editMaintenance", maint);
      //         },

      //         removeMaintenance: function (id) {
      //           this.$eventHub.$emit("_removeMaintenance", id);
      //         },
      //       },
      //     }),
      //   };
      // },
    };
  },
  created() {
    // this.dateRange = this.pluginStartDate;
    document.title = "Record Pumps Maintenance:: Epump Retail Outlet";
    this.$eventHub.$on("_removeMaintenance", (id) => {
      this.deleteMaintenance(id);
    });
    this.$eventHub.$on("__editMaintenance", (maint) => {
      this.fillEditForm(maint);
    });

    this.showLoader = true;
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Faults and Maintenance:: ${branch.name} Retail Outlet`;
    });
    this.getMaintenance();
  },
  beforeDestroy() {
    this.$eventHub.$off("editMaintenance");

    this.$eventHub.$off("_removeMaintenance");
  },
  watch: {
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        this.branchId = this.branch.id;
        if (this.branchId !== null) {
          $(".e-input").keyup(function (e) {
            searchFun(e);
          });
          function searchFun(event) {
            var grid =
              document.getElementsByClassName("e-grid")[0].ej2_instances[0];
            var value = event.target.value;
            grid.search(value);
          }
          this.getMaintenance();
          //     this.getMaintenance();
        }
      }
    },

    pumpStatus: function (newStatus, oldStatus) {
      if (newStatus) {
        this.getMaintenance();
      }
    },
    // dateRange: function(newDate) {
    //   if (newDate) {
    //     this.startDate = this.$moment(newDate, "DD-MM-YYYY").format(
    //       "MMMM D, YYYY"
    //     );

    //   }
    // }
  },
  mounted() {},
  methods: {
    recordMaintenance($event) {
      if (this.status === "select pump status") {
        this.$toast.open({
          message: this.$t("text.pumpsMaintenance.statusMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.servicingCompany) {
        this.$toast.open({
          message: this.$t("text.pumpsMaintenance.servicingMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.technicianName) {
        this.$toast.open({
          message: this.$t("text.pumpsMaintenance.technicianMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.remarks) {
        this.$toast.open({
          message: this.$t("text.pumpsMaintenance.remarkMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.findings) {
        this.$toast.open({
          message: this.$t("text.pumpsMaintenance.findingMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (this.keyReturned === this.$t("text.pumpsMaintenance.trueOrFalse")) {
        this.$toast.open({
          message: this.$t("text.pumpsMaintenance.keyReturnedMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }

      if (this.keyReturned === "true") {
        this.keyReturned = true;
      } else {
        this.keyReturned = false;
      }

      let data = {
        faultId: this.id,
        branchId: this.branchId,
        status: this.status,
        servicingCompany: this.servicingCompany,
        technicianName: this.technicianName,
        remarks: this.remarks,
        findings: this.findings,
        keyReturned: this.keyReturned,
      };

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Pumps/Maintainance`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.isButtonDisabled = true;
          this.$toast.open({
            message: this.$t("text.pumpsMaintenance.successfullyAdded"),
            type: "success",
            duration: 5000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
          this.getMaintenance();
        })
        .catch(() => {
          this.$toast.open({
            message: this.$t("text.pumpsMaintenance.unsuccessfulAdd"),
            type: "error",
            duration: 5000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },

    getMaintenance() {
      let url;
      this.showLoader = true;
      url = `${configObject.apiBaseUrl}/Pumps/MaintainanceHistory/${this.id}`;

      this.axios
        .get(url, configObject.authConfig())
        .then((response) => {
          this.showLoader = false;
          this.maintenanceCount = response.data.length;

          let index = 0;
          response.data.forEach((element) => {
            index = ++index;
            element.date = new Date(element.date).toDateString();
            element.findings = element.description;
          });
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },

    deleteMaintenance(id) {
      const remove = confirm(this.$t("text.pumpsMaintenance.confirmDelete"));
      if (!remove) {
        return;
      }
      let data = {
        id: id,
      };
      fetch(`${configObject.apiBaseUrl}/Pumps/MaintainanceHistory/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: configObject.authConfig().headers.Authorization,
        },
        body: JSON.stringify(data),
      })
        .then((res) => {
          this.$toast.open({
            message: this.$t("text.pumpsMaintenance.successfullyDeleted"),
            type: "success",
            duration: 4000,
          });
          this.getMaintenance();
        })
        .catch((error) => {
          this.$toast.open({
            message: this.$t("text.pumpsMaintenance.unsuccessfulDelete"),
            type: "error",
            duration: 4000,
          });
        });
    },

    // EDIT/UPDATE FUNCTIONALITY
    //     fillEditForm(maint) {
    //       this.formMode = "edit";
    //       this.maintObj = maint;
    //       console.log(maint);
    //     },

    //     editPumpMaintenance($event) {
    //       if (!this.maintObj.servicingCompany) {
    //         this.$toast.open({
    //           message: this.$t("text.pumpsMaintenance.servicingMissing"),
    //           type: "error",
    //           duration: 5000,
    //         });
    //         return;
    //       }
    //       if (!this.maintObj.technicianName) {
    //         this.$toast.open({
    //           message: this.$t("text.pumpsMaintenance.technicianMissing"),
    //           type: "error",
    //           duration: 5000,
    //         });
    //         return;
    //       }
    //       if (!this.maintObj.remarks) {
    //         this.$toast.open({
    //           message: this.$t("text.pumpsMaintenance.remarkMissing"),
    //           type: "error",
    //           duration: 5000,
    //         });
    //         return;
    //       }
    //       if (!this.maintObj.findings) {
    //         this.$toast.open({
    //           message: this.$t("text.pumpsMaintenance.findingMissing"),
    //           type: "error",
    //           duration: 5000,
    //         });
    //         return;
    //       }
    //       if (!this.maintObj.findings) {
    //         this.$toast.open({
    //           message: this.$t("text.pumpsMaintenance.findingMissing"),
    //           type: "error",
    //           duration: 5000,
    //         });
    //         return;
    //       }

    //       if (this.maintObj.keyReturned === "true") {
    //         this.maintObj.keyReturned = true;
    //       } else {
    //         this.maintObj.keyReturned = false;
    //       }

    //       let data = {
    //         faultId: this.maintObj.id,
    //         servicingCompany: this.maintObj.servicingCompany,
    //         technicianName: this.maintObj.technicianName,
    //         findings: this.maintObj.findings,
    //         remarks: this.maintObj.remarks,
    //         keyReturned: this.maintObj.keyReturned,
    //       };

    //       data.status = this.status;
    //       console.log(data);
    //       this.isButtonDisabled = true;
    //       $(".loader").show();
    //       this.axios
    //         .put(
    //           `${configObject.apiBaseUrl}/Pumps/Maintainance`,
    //           data,
    //           configObject.authConfig()
    //         )
    //         .then(() => {
    //           this.isButtonDisabled = true;
    //           (this.pumpFunctional = null),
    //             (this.keyReturned = null),
    //             this.$toast.open({
    //               message: this.$t("text.pumpsMaintenance.successfullyEdited"),
    //               type: "success",
    //               duration: 5000,
    //             });
    //           $(".loader").hide();
    //           this.isButtonDisabled = false;
    //           this.getMaintenance();
    //         })
    //         .catch(() => {
    //           this.$toast.open({
    //             message: this.$t("text.pumpsMaintenance.unsuccessfulEdit"),
    //             type: "error",
    //             duration: 5000,
    //           });
    //           this.isButtonDisabled = false;
    //           $(".loader").hide();
    //         });
    //     },

    //     changeFormMode() {
    //       this.formMode = "create";
    //     },

    sortComparer(reference, comparer) {
      reference = this.$moment(reference, "DD/MM/YYYY  hh:mm A").format();
      comparer = this.$moment(comparer, "DD/MM/YYYY  hh:mm A").format();
      if (reference < comparer) {
        return -1;
      } else if (reference > comparer) {
        return 1;
      } else {
        return 0;
      }
    },
    selectItem(status) {
      this.pumpStatus = status;
      this.getMaintenance();
    },
    toggleTransactionsDropDown() {
      this.showStatusOPtions = !this.showStatusOPtions;
    },

    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },

    convertThousand(request) {
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
